import { render, staticRenderFns } from "./ScoringModel.vue?vue&type=template&id=75669e8b&scoped=true&lang=pug&"
import script from "./ScoringModel.vue?vue&type=script&lang=js&"
export * from "./ScoringModel.vue?vue&type=script&lang=js&"
import style0 from "./ScoringModel.vue?vue&type=style&index=0&id=75669e8b&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75669e8b",
  null
  
)

/* custom blocks */
import block0 from "./ScoringModel.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports